"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleValueText = exports.SingleValueLeading = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../../../icons");
var variables_1 = require("../../../../../style/variables");
var data_display_1 = require("../../../../data-display");
var Text_1 = __importDefault(require("../../../../Text"));
var utils_1 = require("../../utils");
var layout_1 = require("../../../../layout");
var SingleValueLeading = function (_a) {
    var _b = _a.optionType, optionType = _b === void 0 ? 'default' : _b, label = _a.label, _c = _a.selectType, selectType = _c === void 0 ? 'default' : _c, _d = _a.icon, Icon = _d === void 0 ? icons_1.User : _d, imageUrl = _a.imageUrl, disabled = _a.disabled, size = _a.size;
    switch (selectType) {
        case 'dot':
            return (react_1.jsx(data_display_1.Dot, { size: "md", color: label ? 'Success' : 'Gray', disabled: disabled }));
        case 'avatar':
            return (react_1.jsx(data_display_1.Avatar, { name: "", placeholderType: "icon", size: optionType === 'default' ? 'xs' : 'sm', sizeConfig: size === 'sm' ? {
                    groupMargin: 0,
                    font: 0,
                    iconFont: 14,
                    root: 20,
                    indicator: 0,
                } : undefined, src: imageUrl, placeholderIcon: Icon, css: { opacity: disabled ? 0.4 : 1 } }));
        case 'icon':
            return (react_1.jsx(Icon, { size: optionType === 'default' ? 16 : 28, className: "icon", color: "var(" + (disabled ? variables_1.RootColor.Gray.LIGHT_1 : variables_1.RootColor.Gray.DARK_2) + ")" }));
        case 'default':
            if (imageUrl) {
                return (react_1.jsx(data_display_1.Avatar, { name: "", placeholderType: "icon", size: "xs", sizeConfig: size === 'sm' ? {
                        groupMargin: 0,
                        font: 0,
                        iconFont: 14,
                        root: 20,
                        indicator: 0,
                    } : undefined, src: imageUrl, placeholderIcon: Icon, css: { opacity: disabled ? 0.4 : 1 } }));
            }
            return null;
    }
    return null;
};
exports.SingleValueLeading = SingleValueLeading;
var overflowStyle = react_1.css({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
});
var SingleValueText = function (_a) {
    var _b = _a.optionType, optionType = _b === void 0 ? 'default' : _b, size = _a.size, disabled = _a.disabled, label = _a.label, subLabel = _a.subLabel, _c = _a.title, title = _c === void 0 ? null : _c;
    return (react_1.jsx(layout_1.Flex, { inline: true, css: { overflow: 'hidden', textOverflow: 'ellipsis' }, direction: optionType === 'default' ? 'row' : 'column', title: title ? title : utils_1.formatTitle(label, subLabel), gap: optionType === 'default' ? 8 : 0 },
        react_1.jsx(Text_1.default.Body, { css: overflowStyle, size: size === 'sm' ? 'sm' : 'default', color: "var(" + (disabled ? variables_1.TextColor.DISABLED : variables_1.RootColor.Gray.DARK_4) + ")" }, label),
        subLabel ? (react_1.jsx(Text_1.default.Body, { css: overflowStyle, size: size === 'sm' ? 'sm' : 'default', color: "var(" + (disabled ? variables_1.TextColor.DISABLED : variables_1.RootColor.Gray.DEFAULT) + ")" }, subLabel)) : null));
};
exports.SingleValueText = SingleValueText;
